import React from "react";

// Lightweight drop-in replacement for `react-world-flags`.
//
// `react-world-flags` bundles the SVG data for every country (~3.7 MB) into the
// main JS bundle just to render one flag at a time. This component instead loads
// only the requested flag on demand as an <img>, keeping that weight out of the
// bundle. The public API (`code`, `height`) matches how the app used the library.
const FLAG_CDN_BASE = "https://flagcdn.com";

export default function Flag({code, height, style, ...props}) {
    if (!code) return null;
    const normalized = String(code).toLowerCase();
    return (
        <img
            src={`${FLAG_CDN_BASE}/${normalized}.svg`}
            height={height}
            alt={String(code).toUpperCase()}
            loading="lazy"
            decoding="async"
            style={{display: "block", width: "auto", ...style}}
            onError={(event) => {
                event.currentTarget.style.visibility = "hidden";
            }}
            {...props}
        />
    );
}
